import { attr, Model } from 'redux-orm';
import { createAction, createLoadConst } from '../util';

export default class OneTimePasscodeAudit extends Model {
  static get modelName() {
    return 'OneTimePasscodeAudit';
  }

  static reducer({ type, data }, OneTimePasscodeAudit) {
    switch (type) {
      case LOAD.SUCCESS:
        OneTimePasscodeAudit.delete();
        data.response.forEach((r) => {
          OneTimePasscodeAudit.upsert(r);
        });
        break;

      default:
        break;
    }
  }

  /**
   * Declaring all data fields is recommended as the library doesn't have to
   * redefine getters and setters when instantiating Models
   * */
  static get fields() {
    return {
      byAdminUserId: attr(),
      bySystemUser: attr(),
      byUserId: attr(),
      changelog: attr(),
      id: attr(),
      logAt: attr(),
      logOp: attr(),
      otpId: attr(),
      time: attr(), // derived
      title: attr(), // derived
    };
  }
}

export const LOAD = createLoadConst(OneTimePasscodeAudit.modelName);
export const load = createAction(LOAD);
